import { useSimpleChoicesStore } from '@/features/ChoicesLists/Simple/store';
import type { SimpleChoiceType } from '@/features/ChoicesLists/Simple/types';

export const formatChoice =
  (choice: SimpleChoiceType) => (value: string | number) => {
    const simpleChoiceStore = useSimpleChoicesStore();
    simpleChoiceStore.loadChoice(choice);

    return simpleChoiceStore.getLabel(choice, value);
  };
